import PropTypes from 'prop-types';
import React from 'react';
import gettext from '@eb/gettext';
import NotificationScreen from '../../components/NotificationScreen';
import {
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
} from '../../constants';
import { PAGE_HEADER_INFO_MAP } from '../../constants/messages';

const _getSubtitleText = (statusType, email) => {
    const subtTitleTextMap = {
        [RESET_PASSWORD_STATUS_PATH]: gettext(
            'We sent an email to %(email)s with instructions to reset your password.',
            { email },
        ),
        [SOFT_ACCOUNT_STATUS_PATH]: gettext(
            "Looks like you're already in our system! Check your email at %(email)s to create a new password.",
            { email },
        ),
    };

    return subtTitleTextMap[statusType];
};

export default class StatusPage extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
    };

    render() {
        const { email, route } = this.props;
        const { path: statusType } = route;

        const pageHeaderInfo = PAGE_HEADER_INFO_MAP[statusType];

        //Need to conditionally check if the email is present and update copy accordingly
        //in case the user refreshes the notification page and we lose the email from state.
        const subtitleText = email
            ? _getSubtitleText(statusType, email)
            : pageHeaderInfo.subtitleText;

        return (
            <div className="eds-l-mar-vert-14">
                <NotificationScreen
                    iconType={pageHeaderInfo.iconType}
                    iconColor={pageHeaderInfo.iconColor}
                    headerText={pageHeaderInfo.headerText}
                    subtitleText={subtitleText}
                />
            </div>
        );
    }
}
